import e, { useRef as m } from "react";
import { handleKeyBoardNavigation as u } from "./handleKeyBoardNavigation.js";
import { Text as _ } from "../../../Text/Text.js";
import { cls as p } from "../../../../helpers/cls.js";
const d = _ref => {
  let {
    label: i,
    icon: o,
    badge: n,
    selected: t,
    disabled: b,
    onSelectTab: a,
    id: l,
    hidden: r
  } = _ref;
  const s = m(null);
  return r ? null : e.createElement("button", {
    className: p("olx-tabs__tab-button", t && "olx-tabs__tab-button--selected", b && "olx-tabs__tab-button--disabled"),
    id: l,
    role: "tab",
    "aria-selected": t,
    "aria-controls": "panel-".concat(l),
    onClick: () => a == null ? void 0 : a(l),
    onKeyDown: c => u({
      event: c,
      tabButtonRef: s,
      onSelectTab: a
    }),
    tabIndex: t ? 0 : -1,
    disabled: b,
    ref: s,
    "data-ds-component": "DS-Tabs-Button",
    "data-testid": "tab-button"
  }, o && e.createElement("span", {
    className: "olx-tabs__tab-icon"
  }, o), n && e.createElement("span", {
    className: "olx-tabs__tab-badge"
  }, n), e.createElement(_.BodyMedium, {
    weight: "semibold",
    className: "olx-tabs__tab-label"
  }, i));
};
d.displayName = "Tab";
export { d as Tab };